// @ts-nocheck
import { ITempProjectModel } from '../models/TempProjectModel';
import SelectProject from './SelectProject';
import LocalizationHelper from '../../helpers/TranslationHelper';
import LocalizationContext from '../../shared/contexts/LocalizationContext';
import { LocalizationEntity } from '../../shared/models/localization';
import { useContext } from 'react';

interface INotAssignedProjectBoxProps {
  projects: ITempProjectModel[];
  setSelectedProjectId: (id: number | null) => void;
  selectedProjectId: number;
  error: string;
}
export const NotAssignedProjectBox: React.FC<INotAssignedProjectBoxProps> = ({
  projects,
  setSelectedProjectId,
  selectedProjectId,
  error,
}) => {
  const localization = useContext<Array<LocalizationEntity>>(LocalizationContext);
  return (
    <div className="card p-3 shadow-sm my-3" style={{ maxWidth: '500px', margin: '0 auto' }}>
      <h5 className="text-center text-danger mb-3">
        {error
          ? LocalizationHelper.getLocaleEntityValue(
              localization,
              'ZSite.Frontend.Kanban.NoProjectWarning',
              'Warning: There is no such project'
            )
          : LocalizationHelper.getLocaleEntityValue(
              localization,
              'ZSite.Frontend.Kanban.NotAsignedWarning',
              'You are not asigned to this project'
            )}
      </h5>
      <p className="text-center text-muted mb-4">
        {error
          ? LocalizationHelper.getLocaleEntityValue(
              localization,
              'ZSite.Frontend.Kanban.OpenAnotherProjectMessage',
              'Please, open another project'
            )
          : LocalizationHelper.getLocaleEntityValue(
              localization,
              'ZSite.Frontend.Kanban.ContactManagerMessage',
              'Please contact your manager to get assigned to a project.'
            )}
      </p>
      {projects && (
        <div className="selectors">
          <SelectProject
            onChange={setSelectedProjectId}
            projects={projects}
            selectProjectId={selectedProjectId}
          />
        </div>
      )}
    </div>
  );
};
